import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isLimitedEditionSelector } from '../../../../../redux/product/product.selectors';
import { resetPopupWizard, moveToPopupNextStep } from '../../../../../redux/collect-sizes/collect-sizes.actions';
import { GreetingsDialog as GreetingsDialogComponent } from './greetings-dialog';
const mapStateToProps = createStructuredSelector({
  isLimitedEdition: isLimitedEditionSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
    dispatch(resetPopupWizard());
  },
  onNext: () => {
    dispatch(moveToPopupNextStep());
  }
});
export const GreetingsDialog = connect(mapStateToProps, mapDispatchToProps)(GreetingsDialogComponent);